import React from 'react';

const Process = () => {
    return (
        <div>

        </div>
    );
};

export default Process;